<template>
  <RegionIssueOverlay>
    <component
      :is="layout"
      :inspectionId="inspectionId"
      :issueNavBackRoute="issueNavBackRoute"
      :operationId="operationId"
      :organisationId="organisationId"
    />
  </RegionIssueOverlay>
</template>
<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import RegionIssueOverlay from '@/components/regions/regions_issue_overlay.vue';

defineProps({
  organisationId: { type: String, required: true },
  inspectionId: { type: String, required: true },
  operationId: { type: String, required: true },
  shipId: { type: String, required: false, default: null },
  issueId: { type: String, required: false, default: null },
});

const route = useRoute();
const isHme = Object.hasOwn(route.params, 'heavyMobileEquipmentId');

// Set back route based on props
const issueNavBackRoute = computed(() => {
  switch (true) {
    // TODO: update to the regions issue overlay page when ready
    // case isType('ship'):
    //   if (isHme) {
    //     return 'shipRegionsIssuesTypeHme';
    //   }
    //   return 'shipRegionsIssue';
    case isType('operations') && isHme:
      return 'regionsIssuesTypeHme';
    default:
      return 'regionsIssue';
  }
});

/** Dynamically add the issue location based on the type */
const layout = computed(() => {
  switch (true) {
    // TODO: update to the regions issue overlay page when ready
    // case isType('ship'):
    //   if (isHme) {
    //     return defineAsyncComponent(() => import('@/components/ships/location/issue_location_hme.vue'));
    //   }
    //   return defineAsyncComponent(() => import('@/components/ships/location/issue_location_ship.vue'));
    case isType('operations') && isHme:
      return defineAsyncComponent(() => import('@/components/plants/location/issue_location_hme.vue'));
    default:
      return defineAsyncComponent(() => import('@/components/plants/location/issue_location_plant.vue'));
  }
});

function isType(type) {
  return route.fullPath.includes(type);
}
</script>
